import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfTerminalsApiMeta } from "../apiMeta";
import {
  type TerminalVerboseByTerminalIdInput,
  terminalVerboseByTerminalIdInputSchema,
} from "./shared/terminalVerbose.input";
import {
  type TerminalVerbose,
  terminalVerboseSchema,
} from "./shared/terminalVerbose.output";

/**
 * Metadata for the fetchTerminalVerboseByTerminalId endpoint
 */
export const terminalVerboseByTerminalIdMeta = {
  functionName: "fetchTerminalVerboseByTerminalId",
  endpoint: "/terminalVerbose/{TerminalID}",
  inputSchema: terminalVerboseByTerminalIdInputSchema,
  outputSchema: terminalVerboseSchema,
  sampleParams: { TerminalID: 4 },
  endpointDescription:
    "Get comprehensive information for a specific terminal by ID.",
} satisfies EndpointMeta<TerminalVerboseByTerminalIdInput, TerminalVerbose>;

/**
 * Fetch function for retrieving comprehensive information for a specific terminal by ID
 */
const { fetch, useHook } = createFetchAndHook<
  TerminalVerboseByTerminalIdInput,
  TerminalVerbose
>({
  api: wsfTerminalsApiMeta,
  endpoint: terminalVerboseByTerminalIdMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/terminalVerbose.endpoints").terminalVerboseGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving comprehensive information for a specific terminal by ID
 */
export const fetchTerminalVerboseByTerminalId: FetchFactory<
  TerminalVerboseByTerminalIdInput,
  TerminalVerbose
> = fetch;

/**
 * React Query hook for retrieving comprehensive information for a specific terminal by ID
 */
export const useTerminalVerboseByTerminalId: HookFactory<
  TerminalVerboseByTerminalIdInput,
  TerminalVerbose
> = useHook;
